require('./bootstrap');
require('../../../node_modules/bootstrap/js/src/alert.js');
require('../../../node_modules/bootstrap/js/src/tab.js');
require('../../../node_modules/bootstrap/js/src/modal.js');
require('../../../node_modules/bootstrap/js/src/dropdown.js');
require('../../../node_modules/bootstrap/js/src/collapse.js');
//require('../../../node_modules/bootstrap/js/src/tooltip.js');
require('../../../node_modules/bootstrap/js/src/util.js');
require('./common');
require('owl.carousel');
// require('./form-validate');
require('./orderForm');
require('./landing');
require('./search-form');
require('./newsletter');
require('./callback');
require('./chat');
require('./review-popup');
// require('./video');
//require('./mmenu');

// window.$ = $;